import React from 'react';

const btn = {
  width: '100%',
  padding: '14px',
  background: 'linear-gradient(135deg, #009FE3 0%, #0072B1 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  fontSize: '16px',
  fontWeight: '600',
  cursor: 'pointer',
  marginTop: '8px',
};

const btnDisabled = { ...btn, opacity: 0.6, cursor: 'not-allowed' };

// ak-stage-consent — appears right after clicking the email link, before
// TOTP setup. Just needs the same `token` value echoed back to confirm.
export default function ConsentStep({ headerText, token, loading, onSubmit, dark }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <p style={{ color: dark ? '#fff' : '#1a1a1a', marginBottom: '20px' }}>
        {headerText || 'Continue to confirm this email address.'}
      </p>
      <button
        onClick={() => onSubmit({ token })}
        disabled={loading}
        style={loading ? btnDisabled : btn}
      >
        {loading ? 'Please wait…' : 'Confirm'}
      </button>
    </div>
  );
}
